import { Routes } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { CustomInternalServerComponent } from './spartacus/custom/cms-structure/layout/custom-internal-server/custom-internal-server.component';
export const routes: Routes = [
  {
    path: '',
    canActivate: [CmsPageGuard],
    data: { pageLabel: '/ohgar' },
    component: PageLayoutComponent
  },
  {
    path: 'ohbar',
    canActivate: [CmsPageGuard],
    data: { pageLabel: '/ohbar' },
    component: PageLayoutComponent
  },
  {
    path: 'families/:familyCode',
    data: { pageLabel: '/families', cxRoute: 'families' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard]
  },
  {
    path: 'pedidos-y-devoluciones/:orderCode/:mail',
    data: { pageLabel: '/pedidos-y-devoluciones' },
    component: PageLayoutComponent,
    canActivate: [CmsPageGuard]
  },
  {
    path: 'internal-server',
    component: CustomInternalServerComponent
  }
];
